<template>
    <div>
        <div v-if="showModal" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ data.name ? data.name : 'Producto' }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>

                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="product-details-gallery-area mb-7">
                                        <!-- Start Large Image -->
                                        <div v-if="images && images.length > 0">
                                            <div class="product-large-image modal-product-image-large swiper-container">
                                                <swiper v-if="images.length" :key="'main-' + productKey"
                                                    :modules="modules" :space-between="10" :navigation="true"
                                                    :thumbs="{ swiper: thumbsSwiper }" class="main-swiper"
                                                    @swiper="onMainSwiper">
                                                    <swiper-slide v-for="(media, index) in images" :key="index">
                                                        <img :src="media.url" :alt="data.name" class="img-fluid">
                                                    </swiper-slide>
                                                </swiper>
                                            </div>
                                            <!-- Thumbnail swiper -->
                                            <div
                                                class="product-image-thumb modal-product-image-thumb swiper-container pos-relative mt-5">
                                                <swiper v-if="images.length" :key="'thumbs-' + productKey"
                                                    :modules="modules" :space-between="10" :slides-per-view="4"
                                                    :free-mode="true" :watch-slides-progress="true"
                                                    class="thumbnail-swiper" @swiper="setThumbsSwiper">
                                                    <swiper-slide v-for="(media, index) in images" :key="index">
                                                        <img :src="media.url" :alt="data.name"
                                                            class="img-fluid thumbnail"
                                                            @click="handleThumbClick(index)">
                                                    </swiper-slide>
                                                </swiper>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="product-large-image modal-product-image-large swiper-container">
                                                <div class="swiper-wrapper">
                                                    <div class="product-image-large-image swiper-slide img-responsive">
                                                        <img :src="getPath('assets/images/dummy.jpg')" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Large Image -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="modal-product-details-content-area">
                                        <!-- Start  Product Details Text Area-->
                                        <div class="product-details-text">
                                            <h4 class="title">
                                                {{ data.name }}
                                            </h4>
                                            <div>
                                                Sku:<b>{{ data.sku }}</b>
                                            </div>
                                            <div class="block-price">
                                                <div v-if="oldPrice && oldPrice !== price" class="old-price">
                                                    {{ oldPriceFormat }}
                                                </div>
                                                <div v-if="price" class="price">
                                                    {{ finalPrice }}
                                                </div>
                                            </div>

                                            <div class="block-categories">
                                                <span class="badge rounded-pill bg-primary"
                                                    v-for="category in data.categories" :key="category.id">
                                                    {{ category.name }}
                                                </span>
                                            </div>
                                            <div v-if="totalPriceList > 0 && totalPriceList !== totalPrice"
                                                class="priceList">
                                                <div class="titlePriceList">
                                                    Precio de lista:
                                                </div>
                                                <div class="price">{{ totalPriceListFormat }}</div>
                                            </div>
                                        </div>
                                        <!-- End  Product Details Text Area-->
                                        <!-- Start Product Variable Area -->
                                        <div class="product-details-variable">
                                            <!-- Product Variable Single Item -->
                                            <div class="variable-single-item"
                                                v-if="data.variations && data.variations.length > 0">
                                                <span>Variantes</span>
                                                <table class="available-options">
                                                    <thead>
                                                        <tr>
                                                            <th>Código</th>
                                                            <th>Descripción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(variation, index) in data.variations" :key="index">
                                                            <td>
                                                                <b>{{ variation.sku }}</b>
                                                            </td>
                                                            <td>
                                                                {{ variation.name }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-if="allowBuy">
                                                <!-- Product Variable Single Item -->
                                                <div class="pt-2 variable-single-item"
                                                    v-if="data.variations && data.variations.length > 0">
                                                    <span>Opción</span>
                                                    <select class="form-select product-variable-size "
                                                        v-model="selectedVariation">
                                                        <option v-for="(variation, k) in data.variations" :key="k"
                                                            :value="variation.id">
                                                            {{ variation.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <!-- Product Variable Single Item -->
                                                <div class="pt-2 d-flex align-items-center">
                                                    <div class="variable-single-item">
                                                        <span>Cantidad</span>
                                                        <div class="product-variable-quantity">
                                                            <v-plus-minus @update="updateQty" :start="1"></v-plus-minus>
                                                        </div>
                                                    </div>
                                                    <div class="product-add-to-cart-btn">
                                                        <button href="#" @click="addCart()" :disabled="allowAdd"
                                                            style="white-space: nowrap;">+ Agregar al Carro</button>
                                                    </div>
                                                </div>
                                                <!-- End  Product Details Meta Area-->
                                                <!-- precio -->
                                                <div>
                                                    <div class="product-details-text" v-if="totalPrice > 0">
                                                        <div class="price">{{ totalPriceFormat }}</div>
                                                    </div>
                                                </div>
                                                <!-- lista de precio -->
                                                <div v-if="totalPriceList > 0 && totalPriceList !== totalPrice"
                                                    class="priceList">
                                                    <div class="titlePriceList">
                                                        Precio de lista:
                                                    </div>
                                                    <div class="price">{{ totalPriceListFormat }}</div>
                                                </div>

                                            </div>


                                            <!-- Product Variable Single Item -->
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="product-add-to-cart-btn">
                                                    <a :href="data.link">Ver más detalles</a>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End Product Variable Area -->
                                        <div class="modal-product-about-text">
                                            <p>
                                                {{ data.description }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showModal" class="modal-backdrop fade show"></div>
    </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useCommonStore } from "../store/useCommonFrontend";
import vPlusMinus from "./vPlusMinus.vue";

const props = defineProps({
    buy: {
        type: [String, Number],
        default: "0"
    }
});

const emit = defineEmits();
const common = useCommonStore();

// Refs
const thumbsSwiper = ref(null);
const mainSwiper = ref(null);
const productKey = ref(0);
const data = ref({});
const images = ref([]);
const selectedVariation = ref({});
const finalPrice = ref(0);
const finalPriceList = ref(0);
const stock = ref(0);
const price = ref(0);
const priceList = ref(0);
const quantity = ref(1);
const totalPrice = ref(0);
const totalPriceFormat = ref('');
const totalPriceList = ref(0);
const totalPriceListFormat = ref('');
const oldPrice = ref(0);
const oldPriceFormat = ref('');
const allowAdd = ref(true);
const showModal = ref(false);

// Computed
const allowBuy = computed(() => props.buy === 1);
const modules = ref([FreeMode, Navigation, Thumbs]);

// Functions
const setThumbsSwiper = (swiper) => {
    thumbsSwiper.value = swiper;
};

const handleThumbClick = (index) => {
    if (mainSwiper.value) {
        mainSwiper.value.slideTo(index);
    }
};

const onMainSwiper = (swiper) => {
    mainSwiper.value = swiper;
};

const updatePrice = () => {
    const finalPrices = document.querySelectorAll(".final-price-show");

    if (data.value.variations?.length > 0) {
        const index = data.value.variations.findIndex(x => parseInt(x.id, 10) === selectedVariation.value);

        if (index > -1) {
            finalPrices.forEach(x => {
                x.textContent = common.formatCurrency(data.value.variations[index].price, data.value.variations[index].currency_id);
            });
        }
    } else {
        finalPrices.forEach(x => {
            x.textContent = common.formatCurrency(data.value.price, data.value.currency_id);
        });
    }
    totalPrice.value = price.value * quantity.value;
    totalPriceFormat.value = common.formatCurrency(totalPrice.value, data.value.currency_id);
    totalPriceList.value = priceList.value * quantity.value;
    totalPriceListFormat.value = common.formatCurrency(totalPriceList.value, data.value.currency_id);

    allowAdd.value = !(parseInt(stock.value, 10) > 0 && parseInt(stock.value, 10) >= parseInt(quantity.value, 10));
};

const getPath = (image) => `${String(process.env.MIX_APP_HOST)}${image}`;

const addCart = async () => {
    if (allowAdd.value) {
        alert('No puede realizarse la transacción');
        return;
    }

    const myData = {
        variation_id: data.value.variations?.length > 0 ? selectedVariation.value : null,
        quantity: quantity.value,
    };

    try {
        const response = await common.addProductCart(data.value.slug, myData);
        if (response.data.error) {
            alert('Ha ocurrido un error');
        } else {
            closeModal();
            common.updateCartItems();
        }
    } catch (error) {
        console.error('Error adding to cart:', error);
    }
};

const updateQty = (payload) => {
    quantity.value = payload.quantity;
};

const openModal = async (slug) => {
    try {
        // Destruir antes de cargar nuevos datos
        closeModal();

        const url = `${String(process.env.MIX_SENTRY_HOST)}product/${slug}`;
        const response = await common.store({ url, data: {} });

        data.value = { ...response.data };
        images.value = [...response.data.multimedia];
        productKey.value++;
        showModal.value = true;

        // Actualizar el precio
        if (data.value.old_price && data.value.old_price !== data.value.price) {
            oldPrice.value = data.value.old_price;
            oldPriceFormat.value = common.formatCurrency(oldPrice.value, data.value.currency_id);
        }
        if (data.value.variations?.length > 0) {
            const index = data.value.variations.findIndex(x => parseInt(x.id, 10) === selectedVariation.value);
            if (index > -1) {
                price.value = data.value.variations[index].price;
                finalPrice.value = common.formatCurrency(price.value, data.value.variations[index].currency_id);
                priceList.value = data.value.variations[index].price_list;
                finalPriceList.value = common.formatCurrency(priceList.value, data.value.variations[index].currency_id);
                stock.value = data.value.variations[index].stock;
            }
        } else {
            price.value = data.value.price;
            finalPrice.value = common.formatCurrency(price.value, data.value.currency_id);
            priceList.value = data.value.price_list;
            finalPriceList.value = common.formatCurrency(priceList.value, data.value.currency_id);
            stock.value = data.value.stock;
        }

        await nextTick();

        // Nueva verificación después de montar
        if (!mainSwiper.value && Swiper) {
            mainSwiper.value = new Swiper('.main-swiper', {
                // opciones
            });
        }
    } catch (error) {
        console.error('Error loading product:', error);
    }
};

const closeModal = () => {
    showModal.value = false;
    if (mainSwiper.value && !mainSwiper.value.destroyed) {
        mainSwiper.value.destroy();
        mainSwiper.value = null;
    }
    if (thumbsSwiper.value && !thumbsSwiper.value.destroyed) {
        thumbsSwiper.value.destroy();
        thumbsSwiper.value = null;
    }
};

// Watchers
watch(() => data.value.id, () => {
    productKey.value = Date.now();
    if (mainSwiper.value && !mainSwiper.value.destroyed) {
        mainSwiper.value.destroy();
        mainSwiper.value = null;
    }
    if (thumbsSwiper.value && !thumbsSwiper.value.destroyed) {
        thumbsSwiper.value.destroy();
        thumbsSwiper.value = null;
    }
});
watch(() => data.value.id, () => {
    productKey.value = Date.now();
    if (mainSwiper.value) mainSwiper.value.destroy();
    if (thumbsSwiper.value) thumbsSwiper.value.destroy();
});

watch(selectedVariation, updatePrice);
watch(quantity, (newValue) => {
    if (newValue < 1) quantity.value = 1;
    updatePrice();
});

watch(showModal, (newVal) => {
    document.body.classList.toggle('modal-open', newVal);
});

// Lifecycle
onMounted(() => {
    document.querySelectorAll(".modal-trigger").forEach(element => {
        element.addEventListener("click", async (ev) => {
            ev.preventDefault();
            await openModal(element.dataset.productId);
        });
    });
});

onBeforeUnmount(() => {
    if (mainSwiper.value) mainSwiper.value.destroy();
    if (thumbsSwiper.value) thumbsSwiper.value.destroy();
});
</script>
<style scoped>
.thumbnail {
    cursor: pointer;
    transition: opacity 0.3s;
}

.thumbnail:hover {
    opacity: 0.8;
}

.swiper-slide-thumb-active .thumbnail {
    border: 2px solid #007bff;
}

.modal-backdrop.show {
    opacity: 0.5;
}

.modal {
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
